<template>
	<div class="search">

		<div class="search-wrapper form-group d-flex align-items-center justify-content-end w-100">

			<form @submit.prevent="submit()" method="get" class="w-100">
				<input id="search_input" class="form-control flex-fill font-light" maxlength="50" type="text" :placeholder="__('search')" v-model="string" @input="input($event)" ref="search_input">
			</form>

			<!-- Clear results (designed for mobile)-->
			<i class="lnr icon-cross clear_results" @click="clearResults()" v-if="string.length"></i>

			<div class="spinner-wrapper">
				<div class="spinner" v-if="uicontrol.loading">
					<div class="bounce1"></div>
					<div class="bounce2"></div>
					<div class="bounce3"></div>
				</div>
			</div>

			<div class="search_results" v-if="search_results.length">
				<component
					:key="srKey"
					:locale="locale"
					:is="search_result.type"
					:search_result="search_result"
					:is_favorite="isFavorite(search_result.id)"
					v-for="(search_result, srKey) in search_results">
				</component>
			</div>

		</div>

		<div class="search_background" @click="clearResults()" v-if="search_results.length"></div>

	</div>
</template>

<script>

import product from './results/Product.vue';
import empty from './results/Empty.vue';
import debounce from 'lodash.debounce';


// Submit
const submit = () => {

	switch(props.page){

		case 'checkout-guest':

			console.log('Guest mode');

			break;

		case 'create':

			axios.post(route('account.billing.store'), form.data()).then(response => {
				emit('created', response.data.billing_profile)
				doOnFinish(props.onfinish);
			})

			break;


		case 'edit':

			axios.put(route('account.billing.update', {
				uuid : form.uuid
			}), form.data()).then(response => {
				emit('updated', response.data.billing_profile)
				doOnFinish(props.onfinish);
			})

			break;
	}

};

export default {
	name: "Search",
	components: {
		empty,
		product
	},
	props : ['category'],
	data : function(){
		return {
			string: '',
			search_results: [],
			uicontrol : {
				loading : false,
			},
			empty_result: [
				{
					type: 'empty',
					title: 'No results'
				}
			],
			locale : this.$page.props.locale
		}
	},

	watch : {

		string : function(thestring, theoldstring){

			this.uicontrol.loading = (thestring.length > 0) ? true : false;

			if(thestring.length >= 3){
				this.search();
			}else{
				this.search_results = [];
			}

		}

	},

	mounted(){

		// Hide search component if Esc key is pressed
		document.addEventListener('keydown', e => {
			if (e.key == 'Escape')
				this.clearResults();
		});

	},

	beforeUnmount() {
		document.removeEventListener('keydown', () => {}, false)
	},

	methods : {

		submit(){
			this.$inertia.get(route('search.products', {
				q : this.string
			}))
		},

		clearResults(){
			this.search_results = [];
			this.string = '';
		},

		search: debounce(function () {

				var vm = this;

				vm.uicontrol.loading = true;

				axios.post('/search/' + vm.category, {
					'string': vm.string,
				}).then(response => {

					console.log(response.data);

					// Populate list of results
					vm.search_results = (response.data.hits?.length) ? response.data.hits : vm.empty_result;

					// Hide spinner
					vm.uicontrol.loading = false;
					return true;

				}).finally(() => {

					vm.uicontrol.loading = false;

				})

			},

			1000

		),

		isFavorite(result_id){

			return this.$store.state.favorite.favorite_product_ids.includes(result_id);

		},

		input(event){

			if(this.string !== event.target.value)
				this.string = event.target.value;

		}

	}
}
</script>